<script setup>
import KeyboardShortcutsList from './KeyboardShortcutsList.vue';

defineProps({ show: Boolean });
defineEmits(['close']);
</script>

<template>
  <woot-modal :show="show" size="medium" :on-close="() => $emit('close')">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="$t('SIDEBAR_ITEMS.KEYBOARD_SHORTCUTS')"
      />
      <div class="px-8 pt-0 pb-8 mt-6">
        <KeyboardShortcutsList />
      </div>
    </div>
  </woot-modal>
</template>
